<ng-template #ctr>
  <vpfa-modal-content>
    <div class="confirm-modal main-container" [id]="modalId">
      <div class="d-flex flex-row justify-content-center">
        <div style="margin-bottom: 20px">
          <i *ngIf="confirmType === 'warning'" class="icon zmdi zmdi-alert-circle"></i>
          <i *ngIf="confirmType === 'info'" class="icon zmdi zmdi-info"></i>
        </div>
      </div>

      <h3 *ngIf="confirmType === 'warning'" class="heading">
        <ng-container *ngFor="let infoLabelKey of infoLabelsKey; index as i">
          {{ infoLabelKey | translate }} <ng-container *ngIf="infoLabelsKey.length - 1 > i"><br /></ng-container>
        </ng-container>
      </h3>

      <ng-container *ngIf="confirmType === 'info'">
        <p *ngFor="let infoLabelKey of infoLabelsKey; index as i">
          {{ infoLabelKey | translate }} <ng-container *ngIf="infoLabelsKey.length - 1 > i"><br /></ng-container>
        </p>
      </ng-container>

      <div class="d-flex flex-row justify-content-center gap-10px">
        <div>
          <vpfa-modal-button class="cancel-btn" [outline]="true" [border]="false" (click)="confirmResult.emit(false)">
            <span class="cancel">{{ noLabelKey | translate }}</span>
          </vpfa-modal-button>
        </div>
        <div>
          <vpfa-modal-button class="confirm-btn" [outline]="true" [border]="false" (click)="confirmResult.emit(true)">
            <span class="confirm">
              {{ yesLabelKey | translate }}
            </span>
          </vpfa-modal-button>
        </div>
      </div>
    </div>
  </vpfa-modal-content>
</ng-template>
